import { StorageKey } from '@shared/enums/storage-keys.enum';

export const AUTH_RELATED_STORAGE_KEYS = [
  StorageKey.access,
  StorageKey.refresh,
  StorageKey.roles,
  StorageKey.sessionUser,
  StorageKey.probate,
  StorageKey.tax,
  StorageKey.decedent,
  StorageKey.will,
  StorageKey.overview,
  StorageKey.subscribers,
  StorageKey.documents,
  StorageKey.availableSections,
  StorageKey.court,
  StorageKey.selectedSubscriberId,
  StorageKey.targetProbateId,
  StorageKey.noKnownLegalHeirs,
];
